// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// ANTD
import Carousel from 'antd/lib/carousel';
import 'antd/lib/carousel/style/css'; // for css
import PageContainer from 'components/common/PageContainer';

const styles = {
  img: {
    height: 500 * 1.5, // natural dimensions are 660x500
    width: 660 * 1.5,
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 105,
    textAlign: 'center',
    fontSize: 18,
    width: '90%',
    maxWidth: '800px',
  },
};

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 105px;
  text-align: center;
  font-size: 18px;
  width: 90%;
  max-width: 800px;
  @media only screen and (max-width: 400px) {
    height: 145px;
    margin: 15px auto;
  }
`;

const Container = styled.div`
  margin: 15px auto;
  position: relative;
  padding-top: 50px;
  padding-bottom: 50px;
  height: 1000px;
  background: #ebeff1;
  @media only screen and (max-width: 400px) {
    height: 600px;
  }

  .slick-slide {
    text-align: center;
    width: 100%;
    height: 325px;
    max-height: 325px;
    img {
      max-width: 100%;
    }
  }
  .slick-dots {
    display: block !important;
    height: 20px;
    bottom: 40px;
    li {
      margin: 0 12px;
      background: #bee0eb;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      button {
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background: #bee0eb;
        &:hover {
          opacity: 1;
        }
      }
      &.slick-active {
        background: #3584b1;
        button {
          opacity: 1;
          background: #3584b1;
          width: 10px;
          height: 10px;
          border-radius: 5px;
        }
      }
    }
  }
`;

//------------------------------------------------------------------------------
// COMPONENT:
//------------------------------------------------------------------------------
class PlanCarouselImages extends React.Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  next() {
    this.slider.innerSlider.slickNext();
  }

  previous() {
    this.slider.innerSlider.slickPrev();
  }

  renderImages = () => {};

  render() {
    const { plan } = this.props;

    return (
      <Container id="plan-carousel">
        <PageContainer>
          <Carousel
            ref={c => {
              this.slider = c;
            }}
            arrows
          >
            {plan.carouselImages.map(item => {
              const key = item.url + Math.random();
              return (
                <div
                  role="button"
                  tabIndex={0}
                  key={key}
                  className="Public-PlanSingle__PlanSliderImage"
                  onClick={this.next}
                >
                  <img key={key} src={item.url} alt="something" className="mx-auto" />
                  <TextContainer>{item.text}</TextContainer>
                </div>
              );
            })}
          </Carousel>
        </PageContainer>
      </Container>
    );
  }
}

export default PlanCarouselImages;



// WEBPACK FOOTER //
// ./src/routes/app-dashboard-preview/CarouselImages/index.js